export const additionalCustomerDetailsClasses = {
  container: 'flex flex-col items-center justify-between *:mb-3!',
  headerContainer: 'w-full! flex items-center justify-around',
  infoTooltip: 'text-[24px] text-[#026EA1] cursor-pointer m-2',
};

export const creditTaxEulerClasses = {
  textFields: 'flex-1',
  creditContainer:
    'bg-white flex flex-wrap items-center justify-around shadow-md mr-3! p-2 py-2 ',
};

export const insuranceClasses = {
  textFields: 'w-full! max-w-full',
  creditContaoiner:
    'bg-white flex flex-wrap items-center justify-around shadow-md mr-3!',
  dateField: 'w-full! max-w-full',
  tableBg: 'bg-white',
  tableRow: ' border-t! border-[#e0e0e0]! bg-white! nth-1:border-none! ',
  deleteIcon: 'text-[#B00020] cursor-pointer',
  tableFooter:
    'text-base font-normal font-weight-700 leading-20.02 tracking-0.17 text-black bg-white!',
  tableFooterRow: 'border-t    border-[#e0e0e0] ',
  addIcon: 'text-[#0070A2] cursor-pointer',
  mainContainer: 'ml-[2px] mt-3 gap-5!',
  messageTextArea: 'mt-3!',
};

export const invoicingClasses = {
  textFields: 'w-full! max-w-full p-2',
  invoiceContainer: 'ml-[2px] mt-3 gap-5!',
  fieldsContainer: 'mt-3!',
  checkboxContainer: 'flex gap-2 flex-wrap border border-[#c4c4c4] rounded-md',
  checkboxInnerContainer:
    'w-full border-b border-[#c4c4c4] last:border-0! py-px! px-2! relative',
};

export const outstandingInvoicesClasses = {
  buttonClass: 'bg-[#468DB5]! text-white!',
  badgeClass:
    'bg-white w-[20px] h-[20px] rounded-full text-black text-center ml-2!',
  cardStartClass: 'flex! items-center! justify-center!',
};

export const addressClasses = {
  textFields: 'w-full! max-w-full',
  buttonClass: 'bg-[#468DB5]! text-white!',
};
